import { styled } from 'styled-components';

export const Line = styled.div<{ big?: boolean; color: 'error' | 'dark' }>`
    display: flex;
    justify-content: space-between;
    font-size: ${({ big }) => (big ? '16px' : '14px')};
    font-weight: ${({ big }) => (big ? 700 : 500)};
    text-align: left;
    color: ${({ theme, color }) => theme.color[color]};

    span {
        :last-child {
            text-align: right;
        }
    }

    div {
        display: flex;
        align-items: center;
        gap: 10px;
    }
`;
